console.log("I am from metaobject-dropdown.js");

let AToEHeader = document.getElementById('aToE');
let FToJHeader = document.getElementById('fToJ');
let KToOHeader = document.getElementById('kToO');
let PToTHeader = document.getElementById('pToT');
let UToZHeader = document.getElementById('uToZ');
let allHeaders = document.querySelectorAll('.list-item-alphabet-header');

// let AToEContent = document.querySelectorAll('.item-aToE');
// let FToJContent = document.querySelectorAll('.item-fToJ');
// let KToOContent = document.querySelectorAll('.item-kToO');
// let PToTContent = document.querySelectorAll('.item-pToT');
// let UToZContent = document.querySelectorAll('.item-uToZ');

let allContent = document.querySelectorAll('.list-item-alphabet');

AToEHeader.addEventListener('click', function () {
  allHeaders.forEach(function (item) {
    item.classList.remove('active');
  });
  AToEHeader.classList.add('active');

  allContent.forEach(function (item) {
    item.style.display = 'none';
  });
  document.querySelectorAll('.item-aToE').forEach(function (item) {
    item.style.display = 'block';
  });
});

FToJHeader.addEventListener('click', function () {
  allHeaders.forEach(function (item) {
    item.classList.remove('active');
  });
  FToJHeader.classList.add('active');
  allContent.forEach(function (item) {
    item.style.display = 'none';
  });
  document.querySelectorAll('.item-fToJ').forEach(function (item) {
    item.style.display = 'block';
  });
});

KToOHeader.addEventListener('click', function () {
  allHeaders.forEach(function (item) {
    item.classList.remove('active');
  });
  KToOHeader.classList.add('active');
  allContent.forEach(function (item) {
    item.style.display = 'none';
  });
  document.querySelectorAll('.item-kToO').forEach(function (item) {
    item.style.display = 'block';
  });
});

PToTHeader.addEventListener('click', function () {
  allHeaders.forEach(function (item) {
    item.classList.remove('active');
  });
  PToTHeader.classList.add('active');
  allContent.forEach(function (item) {
    item.style.display = 'none';
  });
  document.querySelectorAll('.item-pToT').forEach(function (item) {
    item.style.display = 'block';
  });
});

UToZHeader.addEventListener('click', function () {
  allHeaders.forEach(function (item) {
    item.classList.remove('active');
  });
  UToZHeader.classList.add('active');
  allContent.forEach(function (item) {
    item.style.display = 'none';
  });
  document.querySelectorAll('.item-uToZ').forEach(function (item) {
    item.style.display = 'block';
  });
});


let sportsMetTitle = document.getElementById('mensTitle');
let sportsWomTitle = document.getElementById('womensTitle');
let mensSportsList = document.querySelectorAll('.mens-sports');
let womensSportsList = document.querySelectorAll('.women-sports');

sportsMetTitle.addEventListener('click', function () { 
  if (!sportsMetTitle.classList.contains('active')) {
    sportsMetTitle.classList.add('active');
    sportsWomTitle.classList.remove('active');

    mensSportsList.forEach(function (item) {
      item.classList.remove('gen-hidden');
      item.classList.add('gen-grid');
    });

    womensSportsList.forEach(function (item) {
      item.classList.add('gen-hidden');
      item.classList.remove('gen-grid');
    });
  }
});

sportsWomTitle.addEventListener('click', function () {

  console.log("working here")

  if (!sportsWomTitle.classList.contains('active')) {
    sportsWomTitle.classList.add('active');
    sportsMetTitle.classList.remove('active');

    mensSportsList.forEach(function (item) {
      item.classList.add('gen-hidden');
      item.classList.remove('gen-grid');
    });

    womensSportsList.forEach(function (item) {
      item.classList.remove('gen-hidden');
      item.classList.add('gen-grid');
    });
  }
});
